import { TagTypes } from "../../../Api/Types/tagTypes";
import { PagedList } from "../../Shared/Types/common";
import {
	Country,
	CountryListRequest,
	CountryWithImages,
} from "../Types/countryTypes";
import { countriesApi } from "./countriesApi";

const extendedCountriesApi = countriesApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountriesList: builder.query<PagedList<Country>, CountryListRequest>({
      query: (param) => ({
        url: '/countries/list',
        params: param,
      }),
      providesTags: [{ type: TagTypes.Country, id: 'List' }],
    }),
    getCountryWithImages: builder.query<CountryWithImages, number>({
      query: (id) => `/countries/${id}/with-images`,
      providesTags: (result, error, id) => [{ type: TagTypes.CountryImages, id }],
    }),
    // NEW: Upload images using new backend API
    uploadCountryImages: builder.mutation<
      { imageIds: string[]; count: number },
      { countryId: number; files: File[] }
    >({
      query: ({ countryId, files }) => {
        const formData = new FormData();
        files.forEach((file) => formData.append('Files', file)); // Backend expects "Files" (capital F)
        formData.append('Category', 'Country'); // Backend expects "Category"
        formData.append('EntityId', countryId.toString()); // Backend expects "EntityId"

        return {
          url: '/images/upload-multiple',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error, { countryId }) => [
        { type: TagTypes.CountryImages, id: countryId },
      ],
    }),
    // NEW: Delete image by ID (not path)
    deleteCountryImage: builder.mutation<void, { imageId: string; countryId: number }>({
      query: ({ imageId }) => {
        console.log('[deleteCountryImage] Deleting:', { imageId, url: `/images/${imageId}` });

        return {
          url: `/images/${imageId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (result, error, { countryId }) => [
        { type: TagTypes.CountryImages, id: countryId },
      ],
    }),
  }),
  overrideExisting: false,
});
export const {
	useGetCountriesListQuery,
	useUploadCountryImagesMutation,
	useDeleteCountryImageMutation,
	useGetCountryWithImagesQuery,
} = extendedCountriesApi;
